import { render, staticRenderFns } from "./AiGeneratedAllCompanies.vue?vue&type=template&id=f2a3eb38&scoped=true&"
import script from "./AiGeneratedAllCompanies.vue?vue&type=script&lang=ts&"
export * from "./AiGeneratedAllCompanies.vue?vue&type=script&lang=ts&"
import style0 from "./AiGeneratedAllCompanies.vue?vue&type=style&index=0&id=f2a3eb38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a3eb38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VCol,VImg,VRow})
